import { render, staticRenderFns } from "./BaseEditGate.vue?vue&type=template&id=484b4706&scoped=true"
import script from "./BaseEditGate.vue?vue&type=script&lang=js"
export * from "./BaseEditGate.vue?vue&type=script&lang=js"
import style0 from "./BaseEditGate.vue?vue&type=style&index=0&id=484b4706&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "484b4706",
  null
  
)

export default component.exports